const adaptData = ({ search }) => {
    return {}
};

export default adaptData;
